import { useMemo } from "react";
const useSearcherMultiPakDefaultValues = (rootProps)=>{
    const { props  } = rootProps ?? {};
    const productDefaultValue = useMemo(()=>{
        const { items =[]  } = props ?? {};
        return (items.find((item)=>item.radio?.checked) ?? items[0])?.radio?.value;
    }, [
        props
    ]);
    const defaultValues = useMemo(()=>({
            product: productDefaultValue
        }), [
        productDefaultValue
    ]);
    return defaultValues;
};
export default useSearcherMultiPakDefaultValues;

//# sourceMappingURL=useSearcherMultiPakDefaultValues.js.map